

















import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import BusinessRegistrationValidationRequestIcon
  from '../components/BusinessRegistrationValidationRequestIcon.vue'
import { CompanyRegistrationStep } from '../types'

@Component({
  components: {
    BusinessRegistrationValidationRequestIcon,
  },

  data: () => ({
    CompanyRegistrationStep,
  }),
})
export default class FinishRegistration extends Vue {

}
